import { Component, inject, Input } from '@angular/core';
import { ClientService } from '@zero/shared/util-web-app-services';

@Component({
  selector: 'web-design-system-icon',
  standalone: true,
  templateUrl: './icon.component.html',
  styleUrl: './icon.component.scss',
})
export class IconComponent {
  readonly #clientService = inject(ClientService);

  @Input() public name: IconName | string;
  @Input() public size: IconSize = 'default';
  @Input() public color: IconColor = 'default';

  public APP_VERSION: string = this.#clientService.appVersion;
}

export type IconName =
  | 'add-group'
  | 'add-note'
  | 'add-user'
  | 'add'
  | 'ai-conversion'
  | 'aphabetic-down'
  | 'aphabetic-up'
  | 'archive'
  | 'arrow-1'
  | 'arrow-2'
  | 'arrow-3'
  | 'arrow-box-1'
  | 'arrow-box'
  | 'arrow'
  | 'at'
  | 'attachment'
  | 'bandage'
  | 'batterie'
  | 'bell-1'
  | 'bell'
  | 'bitcoin-1'
  | 'bitcoin'
  | 'block-user'
  | 'blockchain-bitcoin'
  | 'book-1'
  | 'book'
  | 'bookmark-1'
  | 'bookmark'
  | 'calculation'
  | 'calendar'
  | 'chain'
  | 'check-group'
  | 'check-user'
  | 'check'
  | 'chess'
  | 'chevron-1'
  | 'chevron-2'
  | 'chevron-3'
  | 'chevron'
  | 'china'
  | 'circle-add'
  | 'circle-subtract'
  | 'clear'
  | 'cloud'
  | 'comment'
  | 'compass-1'
  | 'compass'
  | 'copy'
  | 'credit'
  | 'cross'
  | 'database-lock'
  | 'debit'
  | 'delete-group'
  | 'delete-user'
  | 'digital-brain'
  | 'digital-ident'
  | 'download'
  | 'duplicate'
  | 'edit'
  | 'expand'
  | 'error'
  | 'eye-1'
  | 'eye-2'
  | 'eye'
  | 'faceid'
  | 'farmer'
  | 'filter'
  | 'fire'
  | 'flipflop'
  | 'fractional-trading'
  | 'game-controller'
  | 'gender'
  | 'glass'
  | 'globe'
  | 'house-1'
  | 'house'
  | 'hydrogen'
  | 'image'
  | 'indent'
  | 'info'
  | 'key'
  | 'limit-order'
  | 'line-chart'
  | 'link-out'
  | 'lock-1'
  | 'lock-2'
  | 'lock'
  | 'long-press'
  | 'magnifier'
  | 'mail-1'
  | 'mail'
  | 'medal'
  | 'money-1'
  | 'moneybag'
  | 'money-send'
  | 'money'
  | 'more-1'
  | 'more'
  | 'most-active-buy'
  | 'most-active-sell'
  | 'news'
  | 'oco'
  | 'online-ident'
  | 'owl'
  | 'paperplane'
  | 'payin'
  | 'payout'
  | 'pdf'
  | 'performance-decrease'
  | 'performance-increase'
  | 'pie-chart-1'
  | 'pie-chart'
  | 'pig-1'
  | 'pig'
  | 'pin'
  | 'postman'
  | 'printer'
  | 'qr-code-scan'
  | 'ranking'
  | 'refresh'
  | 'renewable-energy'
  | 'reply'
  | 'revert'
  | 'robot'
  | 'rocket'
  | 'scale'
  | 'secure'
  | 'sepa'
  | 'setting-slider'
  | 'settings'
  | 'share'
  | 'smart-car'
  | 'solar'
  | 'star-1'
  | 'star'
  | 'stop-order'
  | 'stopwatch'
  | 'subtract'
  | 'swipe'
  | 'tag'
  | 'thumb'
  | 'ticket-1'
  | 'ticket'
  | 'timeline'
  | 'touchid'
  | 'traders-club'
  | 'trash'
  | 'tsl'
  | 'user-1'
  | 'user'
  | 'users'
  | 'vacation'
  | 'vr'
  | 'wallet-1'
  | 'wallet'
  | 'warning'
  | 'warren-buffet'
  | 'zero';
export type IconSize = 'default' | 'small' | 'medium' | 'large';
export type IconColor = 'default' | 'action' | 'dimmed' | 'white' | 'red' | 'green' | 'blue' | 'purple';
